var map = {
	"./404": [
		"2239",
		9
	],
	"./404.vue": [
		"2239",
		9
	],
	"./auth/components/Container": [
		"f86e",
		9,
		"chunk-2d22d7f7"
	],
	"./auth/components/Container.vue": [
		"f86e",
		9,
		"chunk-2d22d7f7"
	],
	"./auth/components/MissloginProtection": [
		"cbb8",
		9,
		"chunk-2d221dab"
	],
	"./auth/components/MissloginProtection.vue": [
		"cbb8",
		9,
		"chunk-2d221dab"
	],
	"./auth/router": [
		"f121",
		9
	],
	"./auth/router.js": [
		"f121",
		9
	],
	"./auth/views/Login": [
		"84f4",
		9,
		"chunk-5dc9b29e"
	],
	"./auth/views/Login.vue": [
		"84f4",
		9,
		"chunk-5dc9b29e"
	],
	"./auth/views/PasswordConfirm": [
		"a11d",
		9,
		"chunk-5ddc4457"
	],
	"./auth/views/PasswordConfirm.vue": [
		"a11d",
		9,
		"chunk-5ddc4457"
	],
	"./auth/views/PasswordReset": [
		"1965",
		9,
		"chunk-5dc690fb"
	],
	"./auth/views/PasswordReset.vue": [
		"1965",
		9,
		"chunk-5dc690fb"
	],
	"./auth/views/PasswordSet": [
		"9d6c",
		9,
		"chunk-5dcad58c"
	],
	"./auth/views/PasswordSet.vue": [
		"9d6c",
		9,
		"chunk-5dcad58c"
	],
	"./cabinet/components": [
		"defc",
		9,
		"chunk-62f6a577"
	],
	"./cabinet/components/": [
		"defc",
		9,
		"chunk-62f6a577"
	],
	"./cabinet/components/ButtonsNavigation": [
		"cd86",
		9,
		"chunk-2d222015"
	],
	"./cabinet/components/ButtonsNavigation.vue": [
		"cd86",
		9,
		"chunk-2d222015"
	],
	"./cabinet/components/Sidebar": [
		"121c",
		9,
		"chunk-55ccf3ec"
	],
	"./cabinet/components/Sidebar/": [
		"121c",
		9,
		"chunk-55ccf3ec"
	],
	"./cabinet/components/Sidebar/Container": [
		"418f",
		9,
		"chunk-2d0c0361"
	],
	"./cabinet/components/Sidebar/Container.vue": [
		"418f",
		9,
		"chunk-2d0c0361"
	],
	"./cabinet/components/Sidebar/index": [
		"121c",
		9,
		"chunk-55ccf3ec"
	],
	"./cabinet/components/Sidebar/index.js": [
		"121c",
		9,
		"chunk-55ccf3ec"
	],
	"./cabinet/components/Sidebar/menu": [
		"a6b7",
		9,
		"chunk-37a2bbbe"
	],
	"./cabinet/components/Sidebar/menu/": [
		"a6b7",
		9,
		"chunk-37a2bbbe"
	],
	"./cabinet/components/Sidebar/menu/Container": [
		"c347",
		9,
		"chunk-6f45de90"
	],
	"./cabinet/components/Sidebar/menu/Container.vue": [
		"c347",
		9,
		"chunk-6f45de90"
	],
	"./cabinet/components/Sidebar/menu/Element": [
		"289d",
		9,
		"chunk-2d0b3507"
	],
	"./cabinet/components/Sidebar/menu/Element.vue": [
		"289d",
		9,
		"chunk-2d0b3507"
	],
	"./cabinet/components/Sidebar/menu/Link": [
		"518f",
		9,
		"chunk-2d0c77c0"
	],
	"./cabinet/components/Sidebar/menu/Link.vue": [
		"518f",
		9,
		"chunk-2d0c77c0"
	],
	"./cabinet/components/Sidebar/menu/Nested": [
		"e19f",
		9,
		"chunk-2d2249af"
	],
	"./cabinet/components/Sidebar/menu/Nested.vue": [
		"e19f",
		9,
		"chunk-2d2249af"
	],
	"./cabinet/components/Sidebar/menu/Section": [
		"4039",
		9,
		"chunk-2d0bfed8"
	],
	"./cabinet/components/Sidebar/menu/Section.vue": [
		"4039",
		9,
		"chunk-2d0bfed8"
	],
	"./cabinet/components/Sidebar/menu/index": [
		"a6b7",
		9,
		"chunk-37a2bbbe"
	],
	"./cabinet/components/Sidebar/menu/index.js": [
		"a6b7",
		9,
		"chunk-37a2bbbe"
	],
	"./cabinet/components/TableStickyHeader": [
		"286b",
		9,
		"chunk-2d0b34a8"
	],
	"./cabinet/components/TableStickyHeader.vue": [
		"286b",
		9,
		"chunk-2d0b34a8"
	],
	"./cabinet/components/Tabs": [
		"f1a9",
		9,
		"chunk-2d22c2b9"
	],
	"./cabinet/components/Tabs.vue": [
		"f1a9",
		9,
		"chunk-2d22c2b9"
	],
	"./cabinet/components/UserBar": [
		"eeab",
		9,
		"chunk-2d2311b7"
	],
	"./cabinet/components/UserBar.vue": [
		"eeab",
		9,
		"chunk-2d2311b7"
	],
	"./cabinet/components/index": [
		"defc",
		9,
		"chunk-62f6a577"
	],
	"./cabinet/components/index.js": [
		"defc",
		9,
		"chunk-62f6a577"
	],
	"./cabinet/components/layouts/Base": [
		"4ff7",
		9,
		"chunk-2d0ccfb9"
	],
	"./cabinet/components/layouts/Base.vue": [
		"4ff7",
		9,
		"chunk-2d0ccfb9"
	],
	"./cabinet/components/layouts/Default": [
		"9190",
		9,
		"chunk-2d0e4925"
	],
	"./cabinet/components/layouts/Default.vue": [
		"9190",
		9,
		"chunk-2d0e4925"
	],
	"./cabinet/components/mixins": [
		"644b",
		9,
		"chunk-2d0cf6e2"
	],
	"./cabinet/components/mixins.js": [
		"644b",
		9,
		"chunk-2d0cf6e2"
	],
	"./cabinet/components/sections/Body": [
		"676b",
		9,
		"chunk-2d0d0263"
	],
	"./cabinet/components/sections/Body.vue": [
		"676b",
		9,
		"chunk-2d0d0263"
	],
	"./cabinet/components/sections/Footer": [
		"7cf9",
		9,
		"chunk-2d0e2195"
	],
	"./cabinet/components/sections/Footer.vue": [
		"7cf9",
		9,
		"chunk-2d0e2195"
	],
	"./cabinet/components/sections/Header": [
		"ed10",
		9,
		"chunk-5e5eeef4"
	],
	"./cabinet/components/sections/Header.vue": [
		"ed10",
		9,
		"chunk-5e5eeef4"
	],
	"./cabinet/components/views/Content": [
		"42c7",
		9,
		"chunk-2d0c0c28"
	],
	"./cabinet/components/views/Content.vue": [
		"42c7",
		9,
		"chunk-2d0c0c28"
	],
	"./cabinet/components/views/FilterableList": [
		"998b",
		9,
		"chunk-2d0e6740"
	],
	"./cabinet/components/views/FilterableList.vue": [
		"998b",
		9,
		"chunk-2d0e6740"
	],
	"./cabinet/components/views/Receive": [
		"93cb",
		9
	],
	"./cabinet/components/views/Receive.vue": [
		"93cb",
		9
	],
	"./cabinet/components/views/View": [
		"2b92",
		9,
		"chunk-2d0bd27f"
	],
	"./cabinet/components/views/View.vue": [
		"2b92",
		9,
		"chunk-2d0bd27f"
	],
	"./cabinet/components/views/utils": [
		"9ed4",
		9
	],
	"./cabinet/components/views/utils.js": [
		"9ed4",
		9
	],
	"./cabinet/modules/analytics/components/BarChart": [
		"f3e3",
		9,
		"chunk-a72f8234"
	],
	"./cabinet/modules/analytics/components/BarChart.js": [
		"f3e3",
		9,
		"chunk-a72f8234"
	],
	"./cabinet/modules/analytics/components/BarChartContainer": [
		"05c2",
		9,
		"chunk-a72f8234",
		"chunk-3fa8744c"
	],
	"./cabinet/modules/analytics/components/BarChartContainer.vue": [
		"05c2",
		9,
		"chunk-a72f8234",
		"chunk-3fa8744c"
	],
	"./cabinet/modules/analytics/components/ClientsList": [
		"2113",
		9,
		"chunk-2d0b1997"
	],
	"./cabinet/modules/analytics/components/ClientsList.vue": [
		"2113",
		9,
		"chunk-2d0b1997"
	],
	"./cabinet/modules/analytics/components/ManagersList": [
		"7e26",
		9,
		"chunk-2d0e22c8"
	],
	"./cabinet/modules/analytics/components/ManagersList.vue": [
		"7e26",
		9,
		"chunk-2d0e22c8"
	],
	"./cabinet/modules/analytics/components/ParcelsList": [
		"1dec",
		9,
		"chunk-2d0b6b27"
	],
	"./cabinet/modules/analytics/components/ParcelsList.vue": [
		"1dec",
		9,
		"chunk-2d0b6b27"
	],
	"./cabinet/modules/analytics/components/ShipmentTypesList": [
		"4760",
		9,
		"chunk-2d0c1973"
	],
	"./cabinet/modules/analytics/components/ShipmentTypesList.vue": [
		"4760",
		9,
		"chunk-2d0c1973"
	],
	"./cabinet/modules/analytics/router": [
		"93fe",
		9
	],
	"./cabinet/modules/analytics/router.js": [
		"93fe",
		9
	],
	"./cabinet/modules/analytics/views/Clients/Display": [
		"c326",
		9,
		"chunk-1bde67c8"
	],
	"./cabinet/modules/analytics/views/Clients/Display.vue": [
		"c326",
		9,
		"chunk-1bde67c8"
	],
	"./cabinet/modules/analytics/views/Managers/Display": [
		"1c6d",
		9,
		"chunk-2b12d3d7"
	],
	"./cabinet/modules/analytics/views/Managers/Display.vue": [
		"1c6d",
		9,
		"chunk-2b12d3d7"
	],
	"./cabinet/modules/analytics/views/Parcels/Display": [
		"4f83",
		9,
		"chunk-20405745"
	],
	"./cabinet/modules/analytics/views/Parcels/Display.vue": [
		"4f83",
		9,
		"chunk-20405745"
	],
	"./cabinet/modules/analytics/views/Parcels/ShipmentTypeDisplay": [
		"02e1",
		9,
		"chunk-e5abad8c"
	],
	"./cabinet/modules/analytics/views/Parcels/ShipmentTypeDisplay.vue": [
		"02e1",
		9,
		"chunk-e5abad8c"
	],
	"./cabinet/modules/analytics/views/View": [
		"0ef05",
		9,
		"chunk-a72f8234",
		"chunk-ac31c5f6"
	],
	"./cabinet/modules/analytics/views/View.vue": [
		"0ef05",
		9,
		"chunk-a72f8234",
		"chunk-ac31c5f6"
	],
	"./cabinet/modules/analytics/views/navigation": [
		"9048",
		9,
		"chunk-2d0e44d1"
	],
	"./cabinet/modules/analytics/views/navigation.js": [
		"9048",
		9,
		"chunk-2d0e44d1"
	],
	"./cabinet/modules/analytics/views/transformers": [
		"3343",
		9,
		"chunk-2d0b95d5"
	],
	"./cabinet/modules/analytics/views/transformers.js": [
		"3343",
		9,
		"chunk-2d0b95d5"
	],
	"./cabinet/modules/clients/components/AddressForm": [
		"faf3",
		9,
		"chunk-2d23777e"
	],
	"./cabinet/modules/clients/components/AddressForm.vue": [
		"faf3",
		9,
		"chunk-2d23777e"
	],
	"./cabinet/modules/clients/components/CategoriesRateForm": [
		"93fb",
		9,
		"chunk-2d0e564c"
	],
	"./cabinet/modules/clients/components/CategoriesRateForm.vue": [
		"93fb",
		9,
		"chunk-2d0e564c"
	],
	"./cabinet/modules/clients/components/ExportClientsByDateModal": [
		"6693",
		9,
		"chunk-6411499f"
	],
	"./cabinet/modules/clients/components/ExportClientsByDateModal.vue": [
		"6693",
		9,
		"chunk-6411499f"
	],
	"./cabinet/modules/clients/components/Form": [
		"6353",
		9,
		"chunk-2d0cf311"
	],
	"./cabinet/modules/clients/components/Form.vue": [
		"6353",
		9,
		"chunk-2d0cf311"
	],
	"./cabinet/modules/clients/components/List": [
		"fa36",
		9,
		"chunk-2d237154"
	],
	"./cabinet/modules/clients/components/List.vue": [
		"fa36",
		9,
		"chunk-2d237154"
	],
	"./cabinet/modules/clients/components/RecipientForm": [
		"170d",
		9,
		"chunk-2d0abbd0"
	],
	"./cabinet/modules/clients/components/RecipientForm.vue": [
		"170d",
		9,
		"chunk-2d0abbd0"
	],
	"./cabinet/modules/clients/components/TransactionsGroupList": [
		"5e9b",
		9,
		"chunk-2d0d3b0f"
	],
	"./cabinet/modules/clients/components/TransactionsGroupList.vue": [
		"5e9b",
		9,
		"chunk-2d0d3b0f"
	],
	"./cabinet/modules/clients/components/TransactionsList": [
		"85de",
		9,
		"chunk-2d0de934"
	],
	"./cabinet/modules/clients/components/TransactionsList.vue": [
		"85de",
		9,
		"chunk-2d0de934"
	],
	"./cabinet/modules/clients/router": [
		"733e",
		9
	],
	"./cabinet/modules/clients/router.js": [
		"733e",
		9
	],
	"./cabinet/modules/clients/views/ClientCategoriesRate": [
		"3766",
		9,
		"chunk-703c5760"
	],
	"./cabinet/modules/clients/views/ClientCategoriesRate.vue": [
		"3766",
		9,
		"chunk-703c5760"
	],
	"./cabinet/modules/clients/views/Comments": [
		"6618",
		9,
		"chunk-5310246a"
	],
	"./cabinet/modules/clients/views/Comments.vue": [
		"6618",
		9,
		"chunk-5310246a"
	],
	"./cabinet/modules/clients/views/Create": [
		"6706",
		9,
		"chunk-dd0a1a1e"
	],
	"./cabinet/modules/clients/views/Create.vue": [
		"6706",
		9,
		"chunk-dd0a1a1e"
	],
	"./cabinet/modules/clients/views/CreateAddresses": [
		"76cd",
		9,
		"chunk-f4d6f5b4"
	],
	"./cabinet/modules/clients/views/CreateAddresses.vue": [
		"76cd",
		9,
		"chunk-f4d6f5b4"
	],
	"./cabinet/modules/clients/views/CreateComplaints": [
		"b3a9",
		9,
		"chunk-f8089528"
	],
	"./cabinet/modules/clients/views/CreateComplaints.vue": [
		"b3a9",
		9,
		"chunk-f8089528"
	],
	"./cabinet/modules/clients/views/CreateRecipients": [
		"471c",
		9,
		"chunk-0c1af9c4"
	],
	"./cabinet/modules/clients/views/CreateRecipients.vue": [
		"471c",
		9,
		"chunk-0c1af9c4"
	],
	"./cabinet/modules/clients/views/Edit": [
		"2a90",
		9,
		"chunk-02555431",
		"chunk-2d0c0e63",
		"chunk-0c1af9c4",
		"chunk-2f0ead4b"
	],
	"./cabinet/modules/clients/views/Edit.vue": [
		"2a90",
		9,
		"chunk-02555431",
		"chunk-2d0c0e63",
		"chunk-0c1af9c4",
		"chunk-2f0ead4b"
	],
	"./cabinet/modules/clients/views/List": [
		"90f5",
		9,
		"chunk-64b0f380",
		"chunk-2d0e4adc"
	],
	"./cabinet/modules/clients/views/List/": [
		"90f5",
		9,
		"chunk-64b0f380",
		"chunk-2d0e4adc"
	],
	"./cabinet/modules/clients/views/List/Display": [
		"ff8f",
		9,
		"chunk-64b0f380"
	],
	"./cabinet/modules/clients/views/List/Display.vue": [
		"ff8f",
		9,
		"chunk-64b0f380"
	],
	"./cabinet/modules/clients/views/List/index": [
		"90f5",
		9,
		"chunk-64b0f380",
		"chunk-2d0e4adc"
	],
	"./cabinet/modules/clients/views/List/index.vue": [
		"90f5",
		9,
		"chunk-64b0f380",
		"chunk-2d0e4adc"
	],
	"./cabinet/modules/clients/views/TelegramChats": [
		"446c",
		9,
		"chunk-2d0c0e63"
	],
	"./cabinet/modules/clients/views/TelegramChats.vue": [
		"446c",
		9,
		"chunk-2d0c0e63"
	],
	"./cabinet/modules/clients/views/Transactions": [
		"3db6",
		9,
		"chunk-02555431"
	],
	"./cabinet/modules/clients/views/Transactions/": [
		"3db6",
		9,
		"chunk-02555431"
	],
	"./cabinet/modules/clients/views/Transactions/Display": [
		"3fbd",
		9,
		"chunk-36f24126"
	],
	"./cabinet/modules/clients/views/Transactions/Display.vue": [
		"3fbd",
		9,
		"chunk-36f24126"
	],
	"./cabinet/modules/clients/views/Transactions/index": [
		"3db6",
		9,
		"chunk-02555431"
	],
	"./cabinet/modules/clients/views/Transactions/index.vue": [
		"3db6",
		9,
		"chunk-02555431"
	],
	"./cabinet/modules/clients/views/TransactionsGroups": [
		"f892",
		9,
		"chunk-02555431",
		"chunk-be6fc968"
	],
	"./cabinet/modules/clients/views/TransactionsGroups/": [
		"f892",
		9,
		"chunk-02555431",
		"chunk-be6fc968"
	],
	"./cabinet/modules/clients/views/TransactionsGroups/Display": [
		"1f17",
		9,
		"chunk-02555431",
		"chunk-03969e38"
	],
	"./cabinet/modules/clients/views/TransactionsGroups/Display.vue": [
		"1f17",
		9,
		"chunk-02555431",
		"chunk-03969e38"
	],
	"./cabinet/modules/clients/views/TransactionsGroups/index": [
		"f892",
		9,
		"chunk-02555431",
		"chunk-be6fc968"
	],
	"./cabinet/modules/clients/views/TransactionsGroups/index.vue": [
		"f892",
		9,
		"chunk-02555431",
		"chunk-be6fc968"
	],
	"./cabinet/modules/clients/views/TransactionsGroups/router": [
		"7af1",
		9
	],
	"./cabinet/modules/clients/views/TransactionsGroups/router.js": [
		"7af1",
		9
	],
	"./cabinet/modules/clients/views/navigation": [
		"05dc",
		9
	],
	"./cabinet/modules/clients/views/navigation.js": [
		"05dc",
		9
	],
	"./cabinet/modules/clients/views/transformers": [
		"b060",
		9,
		"chunk-2d20e83e"
	],
	"./cabinet/modules/clients/views/transformers.js": [
		"b060",
		9,
		"chunk-2d20e83e"
	],
	"./cabinet/modules/delivery/modules/categories/components/Form": [
		"93e4",
		9,
		"chunk-2d0e55ff"
	],
	"./cabinet/modules/delivery/modules/categories/components/Form.vue": [
		"93e4",
		9,
		"chunk-2d0e55ff"
	],
	"./cabinet/modules/delivery/modules/categories/components/List": [
		"aa96",
		9,
		"chunk-2d212c33"
	],
	"./cabinet/modules/delivery/modules/categories/components/List.vue": [
		"aa96",
		9,
		"chunk-2d212c33"
	],
	"./cabinet/modules/delivery/modules/categories/router": [
		"a5a6",
		9
	],
	"./cabinet/modules/delivery/modules/categories/router.js": [
		"a5a6",
		9
	],
	"./cabinet/modules/delivery/modules/categories/views/Create": [
		"926c",
		9,
		"chunk-ed7175ae"
	],
	"./cabinet/modules/delivery/modules/categories/views/Create.vue": [
		"926c",
		9,
		"chunk-ed7175ae"
	],
	"./cabinet/modules/delivery/modules/categories/views/Edit": [
		"073b",
		9,
		"chunk-5193c819"
	],
	"./cabinet/modules/delivery/modules/categories/views/Edit/": [
		"073b",
		9,
		"chunk-5193c819"
	],
	"./cabinet/modules/delivery/modules/categories/views/Edit/index": [
		"073b",
		9,
		"chunk-5193c819"
	],
	"./cabinet/modules/delivery/modules/categories/views/Edit/index.vue": [
		"073b",
		9,
		"chunk-5193c819"
	],
	"./cabinet/modules/delivery/modules/categories/views/List": [
		"46ad",
		9,
		"chunk-30f1033f"
	],
	"./cabinet/modules/delivery/modules/categories/views/List/": [
		"46ad",
		9,
		"chunk-30f1033f"
	],
	"./cabinet/modules/delivery/modules/categories/views/List/Display": [
		"d93f",
		9,
		"chunk-68f761ba"
	],
	"./cabinet/modules/delivery/modules/categories/views/List/Display.vue": [
		"d93f",
		9,
		"chunk-68f761ba"
	],
	"./cabinet/modules/delivery/modules/categories/views/List/index": [
		"46ad",
		9,
		"chunk-30f1033f"
	],
	"./cabinet/modules/delivery/modules/categories/views/List/index.vue": [
		"46ad",
		9,
		"chunk-30f1033f"
	],
	"./cabinet/modules/delivery/modules/categories/views/navigation": [
		"c2f2",
		9,
		"chunk-2d2169f1"
	],
	"./cabinet/modules/delivery/modules/categories/views/navigation.js": [
		"c2f2",
		9,
		"chunk-2d2169f1"
	],
	"./cabinet/modules/delivery/modules/categories/views/transformers": [
		"f55e",
		9,
		"chunk-2d22cc95"
	],
	"./cabinet/modules/delivery/modules/categories/views/transformers.js": [
		"f55e",
		9,
		"chunk-2d22cc95"
	],
	"./cabinet/modules/delivery/modules/freight-orders/components/CreateAddress": [
		"fc21",
		9,
		"chunk-ecbd6b2c"
	],
	"./cabinet/modules/delivery/modules/freight-orders/components/CreateAddress.vue": [
		"fc21",
		9,
		"chunk-ecbd6b2c"
	],
	"./cabinet/modules/delivery/modules/freight-orders/components/Form": [
		"0498",
		9,
		"chunk-2d0a3d19"
	],
	"./cabinet/modules/delivery/modules/freight-orders/components/Form.vue": [
		"0498",
		9,
		"chunk-2d0a3d19"
	],
	"./cabinet/modules/delivery/modules/freight-orders/components/HistoryTable": [
		"7c8f",
		9,
		"chunk-2d0e1c30"
	],
	"./cabinet/modules/delivery/modules/freight-orders/components/HistoryTable.vue": [
		"7c8f",
		9,
		"chunk-2d0e1c30"
	],
	"./cabinet/modules/delivery/modules/freight-orders/components/List": [
		"a71e",
		9,
		"chunk-21b517a2"
	],
	"./cabinet/modules/delivery/modules/freight-orders/components/List.vue": [
		"a71e",
		9,
		"chunk-21b517a2"
	],
	"./cabinet/modules/delivery/modules/freight-orders/router": [
		"4269",
		9
	],
	"./cabinet/modules/delivery/modules/freight-orders/router.js": [
		"4269",
		9
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/Create": [
		"67ae",
		9,
		"chunk-2eff2b5d"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/Create.vue": [
		"67ae",
		9,
		"chunk-2eff2b5d"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/Edit/Parcels/Create": [
		"3384",
		9,
		"chunk-2d0b7203",
		"chunk-180ce4c7"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/Edit/Parcels/Create.vue": [
		"3384",
		9,
		"chunk-2d0b7203",
		"chunk-180ce4c7"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/Edit/Parcels/CreateMix": [
		"8ef1",
		9,
		"chunk-2d0d5f71",
		"chunk-5aaf422b"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/Edit/Parcels/CreateMix.vue": [
		"8ef1",
		9,
		"chunk-2d0d5f71",
		"chunk-5aaf422b"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/Edit/Parcels/List": [
		"37e2",
		9,
		"chunk-22b3eab8"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/Edit/Parcels/List.vue": [
		"37e2",
		9,
		"chunk-22b3eab8"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/Edit/Parcels/ParentParcelForm": [
		"e4da",
		9,
		"chunk-2d225a22"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/Edit/Parcels/ParentParcelForm.vue": [
		"e4da",
		9,
		"chunk-2d225a22"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/Edit/View": [
		"de0b",
		9,
		"chunk-0a00f499",
		"chunk-2d0b7203",
		"chunk-2d0d5f71",
		"chunk-646c51a3",
		"chunk-78af5a32"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/Edit/View.vue": [
		"de0b",
		9,
		"chunk-0a00f499",
		"chunk-2d0b7203",
		"chunk-2d0d5f71",
		"chunk-646c51a3",
		"chunk-78af5a32"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/List": [
		"c10b",
		9,
		"chunk-0a00f499",
		"chunk-17f7c850",
		"chunk-b8509986"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/List/": [
		"c10b",
		9,
		"chunk-0a00f499",
		"chunk-17f7c850",
		"chunk-b8509986"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/List/Display": [
		"f0a7",
		9,
		"chunk-17f7c850",
		"chunk-066e1d91"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/List/Display.vue": [
		"f0a7",
		9,
		"chunk-17f7c850",
		"chunk-066e1d91"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/List/DisplayHistory": [
		"fb20",
		9,
		"chunk-1814d43f"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/List/DisplayHistory.vue": [
		"fb20",
		9,
		"chunk-1814d43f"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/List/HistoryDisplayIndex": [
		"8cdf",
		9,
		"chunk-29c4cdd9"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/List/HistoryDisplayIndex.vue": [
		"8cdf",
		9,
		"chunk-29c4cdd9"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/List/index": [
		"c10b",
		9,
		"chunk-0a00f499",
		"chunk-17f7c850",
		"chunk-b8509986"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/List/index.vue": [
		"c10b",
		9,
		"chunk-0a00f499",
		"chunk-17f7c850",
		"chunk-b8509986"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/navigation": [
		"0233",
		9,
		"chunk-2d0a34d8"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/navigation.js": [
		"0233",
		9,
		"chunk-2d0a34d8"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/transformers": [
		"01f9",
		9,
		"chunk-2d0a374a"
	],
	"./cabinet/modules/delivery/modules/freight-orders/views/transformers.js": [
		"01f9",
		9,
		"chunk-2d0a374a"
	],
	"./cabinet/modules/delivery/modules/parcels/components/Form": [
		"1fa9",
		9,
		"chunk-2d0b7203"
	],
	"./cabinet/modules/delivery/modules/parcels/components/Form.vue": [
		"1fa9",
		9,
		"chunk-2d0b7203"
	],
	"./cabinet/modules/delivery/modules/parcels/components/HistoryTable": [
		"650e",
		9,
		"chunk-2d0cfa2a"
	],
	"./cabinet/modules/delivery/modules/parcels/components/HistoryTable.vue": [
		"650e",
		9,
		"chunk-2d0cfa2a"
	],
	"./cabinet/modules/delivery/modules/parcels/components/List": [
		"d1e2",
		9,
		"chunk-b7059584"
	],
	"./cabinet/modules/delivery/modules/parcels/components/List.vue": [
		"d1e2",
		9,
		"chunk-b7059584"
	],
	"./cabinet/modules/delivery/modules/parcels/components/PreviewList": [
		"5b44",
		9,
		"chunk-61bf6c75"
	],
	"./cabinet/modules/delivery/modules/parcels/components/PreviewList.vue": [
		"5b44",
		9,
		"chunk-61bf6c75"
	],
	"./cabinet/modules/delivery/modules/parcels/components/ReceivedCargoForm": [
		"ab71",
		9,
		"chunk-46b6b832"
	],
	"./cabinet/modules/delivery/modules/parcels/components/ReceivedCargoForm.vue": [
		"ab71",
		9,
		"chunk-46b6b832"
	],
	"./cabinet/modules/delivery/modules/parcels/components/SimplyFieldsList": [
		"aa17",
		9,
		"chunk-a8d471f6"
	],
	"./cabinet/modules/delivery/modules/parcels/components/SimplyFieldsList.vue": [
		"aa17",
		9,
		"chunk-a8d471f6"
	],
	"./cabinet/modules/delivery/modules/parcels/components/SubparcelForm": [
		"7112",
		9,
		"chunk-2d0d5f71"
	],
	"./cabinet/modules/delivery/modules/parcels/components/SubparcelForm.vue": [
		"7112",
		9,
		"chunk-2d0d5f71"
	],
	"./cabinet/modules/delivery/modules/parcels/router": [
		"b784",
		9
	],
	"./cabinet/modules/delivery/modules/parcels/router.js": [
		"b784",
		9
	],
	"./cabinet/modules/delivery/modules/parcels/views/ChangeClientRate": [
		"5cd3",
		9,
		"chunk-fabb8bd0"
	],
	"./cabinet/modules/delivery/modules/parcels/views/ChangeClientRate.vue": [
		"5cd3",
		9,
		"chunk-fabb8bd0"
	],
	"./cabinet/modules/delivery/modules/parcels/views/ChangeShipmentModal": [
		"09d7",
		9,
		"chunk-cda3d60e"
	],
	"./cabinet/modules/delivery/modules/parcels/views/ChangeShipmentModal.vue": [
		"09d7",
		9,
		"chunk-cda3d60e"
	],
	"./cabinet/modules/delivery/modules/parcels/views/ChangeStatusModal": [
		"97a1",
		9,
		"chunk-56e3dcc7"
	],
	"./cabinet/modules/delivery/modules/parcels/views/ChangeStatusModal.vue": [
		"97a1",
		9,
		"chunk-56e3dcc7"
	],
	"./cabinet/modules/delivery/modules/parcels/views/ChangeTransfersMethod": [
		"6c7a",
		9,
		"chunk-0566adb2"
	],
	"./cabinet/modules/delivery/modules/parcels/views/ChangeTransfersMethod.vue": [
		"6c7a",
		9,
		"chunk-0566adb2"
	],
	"./cabinet/modules/delivery/modules/parcels/views/Create": [
		"1248",
		9,
		"chunk-2d0b7203",
		"chunk-061ce45e"
	],
	"./cabinet/modules/delivery/modules/parcels/views/Create.vue": [
		"1248",
		9,
		"chunk-2d0b7203",
		"chunk-061ce45e"
	],
	"./cabinet/modules/delivery/modules/parcels/views/CreateNPDocument": [
		"7871",
		9,
		"chunk-0a00f499"
	],
	"./cabinet/modules/delivery/modules/parcels/views/CreateNPDocument.vue": [
		"7871",
		9,
		"chunk-0a00f499"
	],
	"./cabinet/modules/delivery/modules/parcels/views/Edit": [
		"aa30",
		9,
		"chunk-0a00f499",
		"chunk-2d0b7203",
		"chunk-2d0d5f71",
		"chunk-fb92f0b4"
	],
	"./cabinet/modules/delivery/modules/parcels/views/Edit.vue": [
		"aa30",
		9,
		"chunk-0a00f499",
		"chunk-2d0b7203",
		"chunk-2d0d5f71",
		"chunk-fb92f0b4"
	],
	"./cabinet/modules/delivery/modules/parcels/views/List": [
		"e4c1",
		9,
		"chunk-0a00f499",
		"chunk-646c51a3"
	],
	"./cabinet/modules/delivery/modules/parcels/views/List/": [
		"e4c1",
		9,
		"chunk-0a00f499",
		"chunk-646c51a3"
	],
	"./cabinet/modules/delivery/modules/parcels/views/List/Display": [
		"1a9f",
		9,
		"chunk-ecdd92d8"
	],
	"./cabinet/modules/delivery/modules/parcels/views/List/Display.vue": [
		"1a9f",
		9,
		"chunk-ecdd92d8"
	],
	"./cabinet/modules/delivery/modules/parcels/views/List/DisplayHistory": [
		"fa35",
		9,
		"chunk-d9e046d6"
	],
	"./cabinet/modules/delivery/modules/parcels/views/List/DisplayHistory.vue": [
		"fa35",
		9,
		"chunk-d9e046d6"
	],
	"./cabinet/modules/delivery/modules/parcels/views/List/HistoryDisplayIndex": [
		"51ef",
		9,
		"chunk-589bfc4d"
	],
	"./cabinet/modules/delivery/modules/parcels/views/List/HistoryDisplayIndex.vue": [
		"51ef",
		9,
		"chunk-589bfc4d"
	],
	"./cabinet/modules/delivery/modules/parcels/views/List/Preview": [
		"12e3",
		9,
		"chunk-6554957d"
	],
	"./cabinet/modules/delivery/modules/parcels/views/List/Preview.vue": [
		"12e3",
		9,
		"chunk-6554957d"
	],
	"./cabinet/modules/delivery/modules/parcels/views/List/index": [
		"e4c1",
		9,
		"chunk-0a00f499",
		"chunk-646c51a3"
	],
	"./cabinet/modules/delivery/modules/parcels/views/List/index.vue": [
		"e4c1",
		9,
		"chunk-0a00f499",
		"chunk-646c51a3"
	],
	"./cabinet/modules/delivery/modules/parcels/views/Photos": [
		"fc94",
		9,
		"chunk-2d23798e"
	],
	"./cabinet/modules/delivery/modules/parcels/views/Photos.vue": [
		"fc94",
		9,
		"chunk-2d23798e"
	],
	"./cabinet/modules/delivery/modules/parcels/views/navigation": [
		"b1dd",
		9,
		"chunk-2d20f1c5"
	],
	"./cabinet/modules/delivery/modules/parcels/views/navigation.js": [
		"b1dd",
		9,
		"chunk-2d20f1c5"
	],
	"./cabinet/modules/delivery/modules/parcels/views/transformers": [
		"5eff",
		9,
		"chunk-2d0d4086"
	],
	"./cabinet/modules/delivery/modules/parcels/views/transformers.js": [
		"5eff",
		9,
		"chunk-2d0d4086"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/components/Form": [
		"3590",
		9,
		"chunk-704ced76"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/components/Form.vue": [
		"3590",
		9,
		"chunk-704ced76"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/components/HistoryTable": [
		"e5be",
		9,
		"chunk-2d225da9"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/components/HistoryTable.vue": [
		"e5be",
		9,
		"chunk-2d225da9"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/components/List": [
		"4abd",
		9,
		"chunk-086a65cc"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/components/List.vue": [
		"4abd",
		9,
		"chunk-086a65cc"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/components/ReceivedCargoConfirmModal": [
		"bbae",
		9,
		"chunk-2d21a95a"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/components/ReceivedCargoConfirmModal.vue": [
		"bbae",
		9,
		"chunk-2d21a95a"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/router": [
		"60b0",
		9
	],
	"./cabinet/modules/delivery/modules/received-cargoes/router.js": [
		"60b0",
		9
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/Create": [
		"27d5",
		9,
		"chunk-0db69902"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/Create.vue": [
		"27d5",
		9,
		"chunk-0db69902"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/Edit": [
		"0844",
		9,
		"chunk-6020026a"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/Edit.vue": [
		"0844",
		9,
		"chunk-6020026a"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/List": [
		"9f4f",
		9,
		"chunk-7a0e5a0b"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/List/": [
		"9f4f",
		9,
		"chunk-7a0e5a0b"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/List/Display": [
		"7b7a",
		9,
		"chunk-65988156"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/List/Display.vue": [
		"7b7a",
		9,
		"chunk-65988156"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/List/DisplayHistory": [
		"6793",
		9,
		"chunk-c08a7ed2"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/List/DisplayHistory.vue": [
		"6793",
		9,
		"chunk-c08a7ed2"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/List/HistoryDisplayIndex": [
		"24b9",
		9,
		"chunk-168b098d"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/List/HistoryDisplayIndex.vue": [
		"24b9",
		9,
		"chunk-168b098d"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/List/index": [
		"9f4f",
		9,
		"chunk-7a0e5a0b"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/List/index.vue": [
		"9f4f",
		9,
		"chunk-7a0e5a0b"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/Parcels/Create": [
		"9323",
		9,
		"chunk-5e1c508e"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/Parcels/Create.vue": [
		"9323",
		9,
		"chunk-5e1c508e"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/Parcels/Edit": [
		"08e3",
		9,
		"chunk-7dc41daf"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/Parcels/Edit.vue": [
		"08e3",
		9,
		"chunk-7dc41daf"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/Parcels/IntakeForm": [
		"57a7",
		9,
		"chunk-100de084"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/Parcels/IntakeForm.vue": [
		"57a7",
		9,
		"chunk-100de084"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/Parcels/List": [
		"f24b",
		9,
		"chunk-a31ef828"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/Parcels/List.vue": [
		"f24b",
		9,
		"chunk-a31ef828"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/Parcels/transformers": [
		"4f5b",
		9,
		"chunk-2d0cc9f5"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/Parcels/transformers.js": [
		"4f5b",
		9,
		"chunk-2d0cc9f5"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/navigation": [
		"0ade",
		9,
		"chunk-2d0aeb68"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/navigation.js": [
		"0ade",
		9,
		"chunk-2d0aeb68"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/transformers": [
		"ae1d",
		9,
		"chunk-2d213a6d"
	],
	"./cabinet/modules/delivery/modules/received-cargoes/views/transformers.js": [
		"ae1d",
		9,
		"chunk-2d213a6d"
	],
	"./cabinet/modules/delivery/modules/scanning/router": [
		"3f28",
		9
	],
	"./cabinet/modules/delivery/modules/scanning/router.js": [
		"3f28",
		9
	],
	"./cabinet/modules/delivery/modules/scanning/views/Scan": [
		"4faf",
		9,
		"chunk-5cfadada"
	],
	"./cabinet/modules/delivery/modules/scanning/views/Scan.vue": [
		"4faf",
		9,
		"chunk-5cfadada"
	],
	"./cabinet/modules/delivery/modules/scanning/views/transformers": [
		"5e37",
		9,
		"chunk-2d0d3a2a"
	],
	"./cabinet/modules/delivery/modules/scanning/views/transformers.js": [
		"5e37",
		9,
		"chunk-2d0d3a2a"
	],
	"./cabinet/modules/delivery/modules/shipments/components/Form": [
		"23c0",
		9,
		"chunk-11abbe4a"
	],
	"./cabinet/modules/delivery/modules/shipments/components/Form.vue": [
		"23c0",
		9,
		"chunk-11abbe4a"
	],
	"./cabinet/modules/delivery/modules/shipments/components/HistoryTable": [
		"5ced",
		9,
		"chunk-2d0d38e3"
	],
	"./cabinet/modules/delivery/modules/shipments/components/HistoryTable.vue": [
		"5ced",
		9,
		"chunk-2d0d38e3"
	],
	"./cabinet/modules/delivery/modules/shipments/components/List": [
		"aee4",
		9,
		"chunk-2d214089"
	],
	"./cabinet/modules/delivery/modules/shipments/components/List.vue": [
		"aee4",
		9,
		"chunk-2d214089"
	],
	"./cabinet/modules/delivery/modules/shipments/router": [
		"2cde",
		9
	],
	"./cabinet/modules/delivery/modules/shipments/router.js": [
		"2cde",
		9
	],
	"./cabinet/modules/delivery/modules/shipments/views/Create": [
		"1ac3",
		9,
		"chunk-1e8b764e"
	],
	"./cabinet/modules/delivery/modules/shipments/views/Create.vue": [
		"1ac3",
		9,
		"chunk-1e8b764e"
	],
	"./cabinet/modules/delivery/modules/shipments/views/Edit/Freight-orders/View": [
		"7d25",
		9,
		"chunk-0aadaddd"
	],
	"./cabinet/modules/delivery/modules/shipments/views/Edit/Freight-orders/View.vue": [
		"7d25",
		9,
		"chunk-0aadaddd"
	],
	"./cabinet/modules/delivery/modules/shipments/views/Edit/Parcels/List": [
		"9d1c",
		9,
		"chunk-334c29d9"
	],
	"./cabinet/modules/delivery/modules/shipments/views/Edit/Parcels/List.vue": [
		"9d1c",
		9,
		"chunk-334c29d9"
	],
	"./cabinet/modules/delivery/modules/shipments/views/Edit/Parcels/View": [
		"9ca0",
		9,
		"chunk-0a00f499",
		"chunk-2935df7a"
	],
	"./cabinet/modules/delivery/modules/shipments/views/Edit/Parcels/View.vue": [
		"9ca0",
		9,
		"chunk-0a00f499",
		"chunk-2935df7a"
	],
	"./cabinet/modules/delivery/modules/shipments/views/Edit/TrackingInfo": [
		"5101",
		9,
		"chunk-2d0c7693"
	],
	"./cabinet/modules/delivery/modules/shipments/views/Edit/TrackingInfo.vue": [
		"5101",
		9,
		"chunk-2d0c7693"
	],
	"./cabinet/modules/delivery/modules/shipments/views/Edit/View": [
		"e491",
		9,
		"chunk-0a00f499",
		"chunk-646c51a3",
		"chunk-17f7c850",
		"chunk-fa667350"
	],
	"./cabinet/modules/delivery/modules/shipments/views/Edit/View.vue": [
		"e491",
		9,
		"chunk-0a00f499",
		"chunk-646c51a3",
		"chunk-17f7c850",
		"chunk-fa667350"
	],
	"./cabinet/modules/delivery/modules/shipments/views/List": [
		"a602",
		9,
		"chunk-758ac6b0",
		"chunk-0928ed3e"
	],
	"./cabinet/modules/delivery/modules/shipments/views/List/": [
		"a602",
		9,
		"chunk-758ac6b0",
		"chunk-0928ed3e"
	],
	"./cabinet/modules/delivery/modules/shipments/views/List/Display": [
		"a509",
		9,
		"chunk-758ac6b0"
	],
	"./cabinet/modules/delivery/modules/shipments/views/List/Display.vue": [
		"a509",
		9,
		"chunk-758ac6b0"
	],
	"./cabinet/modules/delivery/modules/shipments/views/List/DisplayHistory": [
		"5fd4",
		9,
		"chunk-3a56bab2"
	],
	"./cabinet/modules/delivery/modules/shipments/views/List/DisplayHistory.vue": [
		"5fd4",
		9,
		"chunk-3a56bab2"
	],
	"./cabinet/modules/delivery/modules/shipments/views/List/HistoryDisplayIndex": [
		"3192",
		9,
		"chunk-31fab32e"
	],
	"./cabinet/modules/delivery/modules/shipments/views/List/HistoryDisplayIndex.vue": [
		"3192",
		9,
		"chunk-31fab32e"
	],
	"./cabinet/modules/delivery/modules/shipments/views/List/index": [
		"a602",
		9,
		"chunk-758ac6b0",
		"chunk-0928ed3e"
	],
	"./cabinet/modules/delivery/modules/shipments/views/List/index.vue": [
		"a602",
		9,
		"chunk-758ac6b0",
		"chunk-0928ed3e"
	],
	"./cabinet/modules/delivery/modules/shipments/views/navigation": [
		"0ed0",
		9,
		"chunk-2d0afa37"
	],
	"./cabinet/modules/delivery/modules/shipments/views/navigation.js": [
		"0ed0",
		9,
		"chunk-2d0afa37"
	],
	"./cabinet/modules/delivery/modules/shipments/views/transformers": [
		"bd66",
		9,
		"chunk-2d21ab78"
	],
	"./cabinet/modules/delivery/modules/shipments/views/transformers.js": [
		"bd66",
		9,
		"chunk-2d21ab78"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/components/Form": [
		"0daf",
		9,
		"chunk-84fb2636"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/components/Form.vue": [
		"0daf",
		9,
		"chunk-84fb2636"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/components/HistoryTable": [
		"b73f",
		9,
		"chunk-2d21025e"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/components/HistoryTable.vue": [
		"b73f",
		9,
		"chunk-2d21025e"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/components/List": [
		"ebb0",
		9,
		"chunk-78ac3267"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/components/List.vue": [
		"ebb0",
		9,
		"chunk-78ac3267"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/router": [
		"b5e0",
		9
	],
	"./cabinet/modules/delivery/modules/unidentified-search/router.js": [
		"b5e0",
		9
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/Create": [
		"6da9",
		9,
		"chunk-f7c27a16"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/Create.vue": [
		"6da9",
		9,
		"chunk-f7c27a16"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/Edit": [
		"854b",
		9,
		"chunk-6993dc9a"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/Edit.vue": [
		"854b",
		9,
		"chunk-6993dc9a"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/List": [
		"a060",
		9,
		"chunk-6bed6ee1"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/List/": [
		"a060",
		9,
		"chunk-6bed6ee1"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/List/Display": [
		"b18c",
		9,
		"chunk-cf275e56"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/List/Display.vue": [
		"b18c",
		9,
		"chunk-cf275e56"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/List/DisplayHistory": [
		"f324",
		9,
		"chunk-5e5085e6"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/List/DisplayHistory.vue": [
		"f324",
		9,
		"chunk-5e5085e6"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/List/HistoryDisplayIndex": [
		"991b",
		9,
		"chunk-70cfd7bd"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/List/HistoryDisplayIndex.vue": [
		"991b",
		9,
		"chunk-70cfd7bd"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/List/index": [
		"a060",
		9,
		"chunk-6bed6ee1"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/List/index.vue": [
		"a060",
		9,
		"chunk-6bed6ee1"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/navigation": [
		"922b",
		9,
		"chunk-2d0e4c3f"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/navigation.js": [
		"922b",
		9,
		"chunk-2d0e4c3f"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/transformers": [
		"278d",
		9,
		"chunk-2d0b3127"
	],
	"./cabinet/modules/delivery/modules/unidentified-search/views/transformers.js": [
		"278d",
		9,
		"chunk-2d0b3127"
	],
	"./cabinet/modules/delivery/modules/unidentified/components/Form": [
		"e0ed",
		9,
		"chunk-261f8694"
	],
	"./cabinet/modules/delivery/modules/unidentified/components/Form.vue": [
		"e0ed",
		9,
		"chunk-261f8694"
	],
	"./cabinet/modules/delivery/modules/unidentified/components/HistoryTable": [
		"28eb",
		9,
		"chunk-2d0b3a59"
	],
	"./cabinet/modules/delivery/modules/unidentified/components/HistoryTable.vue": [
		"28eb",
		9,
		"chunk-2d0b3a59"
	],
	"./cabinet/modules/delivery/modules/unidentified/components/List": [
		"4aec",
		9,
		"chunk-b52d2d4c"
	],
	"./cabinet/modules/delivery/modules/unidentified/components/List.vue": [
		"4aec",
		9,
		"chunk-b52d2d4c"
	],
	"./cabinet/modules/delivery/modules/unidentified/router": [
		"58d5",
		9
	],
	"./cabinet/modules/delivery/modules/unidentified/router.js": [
		"58d5",
		9
	],
	"./cabinet/modules/delivery/modules/unidentified/views/Create": [
		"2150",
		9,
		"chunk-2f915603"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/Create.vue": [
		"2150",
		9,
		"chunk-2f915603"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/Edit": [
		"4e95",
		9,
		"chunk-4641f85b"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/Edit.vue": [
		"4e95",
		9,
		"chunk-4641f85b"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/List": [
		"e481",
		9,
		"chunk-103633dc"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/List/": [
		"e481",
		9,
		"chunk-103633dc"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/List/Display": [
		"afa3",
		9,
		"chunk-281cd6e5"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/List/Display.vue": [
		"afa3",
		9,
		"chunk-281cd6e5"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/List/DisplayHistory": [
		"6afd",
		9,
		"chunk-3d47721f"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/List/DisplayHistory.vue": [
		"6afd",
		9,
		"chunk-3d47721f"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/List/HistoryDisplayIndex": [
		"d3bc",
		9,
		"chunk-65a21dd0"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/List/HistoryDisplayIndex.vue": [
		"d3bc",
		9,
		"chunk-65a21dd0"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/List/index": [
		"e481",
		9,
		"chunk-103633dc"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/List/index.vue": [
		"e481",
		9,
		"chunk-103633dc"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/navigation": [
		"4671",
		9,
		"chunk-2d0c15d2"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/navigation.js": [
		"4671",
		9,
		"chunk-2d0c15d2"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/transformers": [
		"334c",
		9,
		"chunk-2d0b9605"
	],
	"./cabinet/modules/delivery/modules/unidentified/views/transformers.js": [
		"334c",
		9,
		"chunk-2d0b9605"
	],
	"./cabinet/modules/delivery/modules/verification/components/Parcels/List": [
		"3545",
		9,
		"chunk-7041c1f0"
	],
	"./cabinet/modules/delivery/modules/verification/components/Parcels/List.vue": [
		"3545",
		9,
		"chunk-7041c1f0"
	],
	"./cabinet/modules/delivery/modules/verification/components/forms/Base": [
		"1f68",
		9,
		"chunk-1f44dbd6"
	],
	"./cabinet/modules/delivery/modules/verification/components/forms/Base.vue": [
		"1f68",
		9,
		"chunk-1f44dbd6"
	],
	"./cabinet/modules/delivery/modules/verification/components/forms/Controller": [
		"6218",
		9,
		"chunk-2d0ceed9"
	],
	"./cabinet/modules/delivery/modules/verification/components/forms/Controller.vue": [
		"6218",
		9,
		"chunk-2d0ceed9"
	],
	"./cabinet/modules/delivery/modules/verification/router": [
		"2be2",
		9
	],
	"./cabinet/modules/delivery/modules/verification/router.js": [
		"2be2",
		9
	],
	"./cabinet/modules/delivery/modules/verification/views/Parcels/List": [
		"8b8c",
		9,
		"chunk-d9be7270"
	],
	"./cabinet/modules/delivery/modules/verification/views/Parcels/List.vue": [
		"8b8c",
		9,
		"chunk-d9be7270"
	],
	"./cabinet/modules/delivery/modules/verification/views/Verify": [
		"9696",
		9,
		"chunk-81ea07f2"
	],
	"./cabinet/modules/delivery/modules/verification/views/Verify.vue": [
		"9696",
		9,
		"chunk-81ea07f2"
	],
	"./cabinet/modules/delivery/modules/verification/views/transformers": [
		"9cd9",
		9,
		"chunk-2d0f0a15"
	],
	"./cabinet/modules/delivery/modules/verification/views/transformers.js": [
		"9cd9",
		9,
		"chunk-2d0f0a15"
	],
	"./cabinet/modules/delivery/router": [
		"ea8b",
		9
	],
	"./cabinet/modules/delivery/router.js": [
		"ea8b",
		9
	],
	"./cabinet/modules/finances/modules/cashbox/components/Form": [
		"8970",
		9,
		"chunk-2d0df290"
	],
	"./cabinet/modules/finances/modules/cashbox/components/Form.vue": [
		"8970",
		9,
		"chunk-2d0df290"
	],
	"./cabinet/modules/finances/modules/cashbox/components/List": [
		"41a1",
		9,
		"chunk-2d0c0823"
	],
	"./cabinet/modules/finances/modules/cashbox/components/List.vue": [
		"41a1",
		9,
		"chunk-2d0c0823"
	],
	"./cabinet/modules/finances/modules/cashbox/router": [
		"233e",
		9
	],
	"./cabinet/modules/finances/modules/cashbox/router.js": [
		"233e",
		9
	],
	"./cabinet/modules/finances/modules/cashbox/views/Create": [
		"bf4f",
		9,
		"chunk-477ceb70"
	],
	"./cabinet/modules/finances/modules/cashbox/views/Create.vue": [
		"bf4f",
		9,
		"chunk-477ceb70"
	],
	"./cabinet/modules/finances/modules/cashbox/views/List": [
		"139c",
		9,
		"chunk-0ceb5f88"
	],
	"./cabinet/modules/finances/modules/cashbox/views/List/": [
		"139c",
		9,
		"chunk-0ceb5f88"
	],
	"./cabinet/modules/finances/modules/cashbox/views/List/Display": [
		"9047",
		9,
		"chunk-158f3615"
	],
	"./cabinet/modules/finances/modules/cashbox/views/List/Display.vue": [
		"9047",
		9,
		"chunk-158f3615"
	],
	"./cabinet/modules/finances/modules/cashbox/views/List/index": [
		"139c",
		9,
		"chunk-0ceb5f88"
	],
	"./cabinet/modules/finances/modules/cashbox/views/List/index.vue": [
		"139c",
		9,
		"chunk-0ceb5f88"
	],
	"./cabinet/modules/finances/modules/cashbox/views/navigation": [
		"1e98",
		9,
		"chunk-2d0b6969"
	],
	"./cabinet/modules/finances/modules/cashbox/views/navigation.js": [
		"1e98",
		9,
		"chunk-2d0b6969"
	],
	"./cabinet/modules/finances/modules/cashbox/views/transformers": [
		"1e8a",
		9,
		"chunk-2d0b6973"
	],
	"./cabinet/modules/finances/modules/cashbox/views/transformers.js": [
		"1e8a",
		9,
		"chunk-2d0b6973"
	],
	"./cabinet/modules/finances/modules/salaries/components/List": [
		"b4d9",
		9,
		"chunk-eab8e21e"
	],
	"./cabinet/modules/finances/modules/salaries/components/List.vue": [
		"b4d9",
		9,
		"chunk-eab8e21e"
	],
	"./cabinet/modules/finances/modules/salaries/router": [
		"da35",
		9
	],
	"./cabinet/modules/finances/modules/salaries/router.js": [
		"da35",
		9
	],
	"./cabinet/modules/finances/modules/salaries/views/List": [
		"e2a8",
		9,
		"chunk-e9f47e9c"
	],
	"./cabinet/modules/finances/modules/salaries/views/List/": [
		"e2a8",
		9,
		"chunk-e9f47e9c"
	],
	"./cabinet/modules/finances/modules/salaries/views/List/Display": [
		"c3cb",
		9,
		"chunk-3cd8b998"
	],
	"./cabinet/modules/finances/modules/salaries/views/List/Display.vue": [
		"c3cb",
		9,
		"chunk-3cd8b998"
	],
	"./cabinet/modules/finances/modules/salaries/views/List/index": [
		"e2a8",
		9,
		"chunk-e9f47e9c"
	],
	"./cabinet/modules/finances/modules/salaries/views/List/index.vue": [
		"e2a8",
		9,
		"chunk-e9f47e9c"
	],
	"./cabinet/modules/finances/modules/salaries/views/navigation": [
		"d051",
		9,
		"chunk-2d21d0de"
	],
	"./cabinet/modules/finances/modules/salaries/views/navigation.js": [
		"d051",
		9,
		"chunk-2d21d0de"
	],
	"./cabinet/modules/finances/modules/salaries/views/transformers": [
		"377a",
		9,
		"chunk-2d0ba564"
	],
	"./cabinet/modules/finances/modules/salaries/views/transformers.js": [
		"377a",
		9,
		"chunk-2d0ba564"
	],
	"./cabinet/modules/finances/modules/transactions/components/Form": [
		"d68c",
		9,
		"chunk-2d21e7f3"
	],
	"./cabinet/modules/finances/modules/transactions/components/Form.vue": [
		"d68c",
		9,
		"chunk-2d21e7f3"
	],
	"./cabinet/modules/finances/modules/transactions/components/List": [
		"dcc4",
		9,
		"chunk-2d2295e6"
	],
	"./cabinet/modules/finances/modules/transactions/components/List.vue": [
		"dcc4",
		9,
		"chunk-2d2295e6"
	],
	"./cabinet/modules/finances/modules/transactions/router": [
		"3274",
		9
	],
	"./cabinet/modules/finances/modules/transactions/router.js": [
		"3274",
		9
	],
	"./cabinet/modules/finances/modules/transactions/views/Create": [
		"00c3",
		9,
		"chunk-9d034ba0"
	],
	"./cabinet/modules/finances/modules/transactions/views/Create.vue": [
		"00c3",
		9,
		"chunk-9d034ba0"
	],
	"./cabinet/modules/finances/modules/transactions/views/CreateModal": [
		"b2df",
		9,
		"chunk-94a74794"
	],
	"./cabinet/modules/finances/modules/transactions/views/CreateModal.vue": [
		"b2df",
		9,
		"chunk-94a74794"
	],
	"./cabinet/modules/finances/modules/transactions/views/List": [
		"91bb",
		9,
		"chunk-50037538",
		"chunk-70356454"
	],
	"./cabinet/modules/finances/modules/transactions/views/List/": [
		"91bb",
		9,
		"chunk-50037538",
		"chunk-70356454"
	],
	"./cabinet/modules/finances/modules/transactions/views/List/Display": [
		"7f99",
		9,
		"chunk-50037538"
	],
	"./cabinet/modules/finances/modules/transactions/views/List/Display.vue": [
		"7f99",
		9,
		"chunk-50037538"
	],
	"./cabinet/modules/finances/modules/transactions/views/List/index": [
		"91bb",
		9,
		"chunk-50037538",
		"chunk-70356454"
	],
	"./cabinet/modules/finances/modules/transactions/views/List/index.vue": [
		"91bb",
		9,
		"chunk-50037538",
		"chunk-70356454"
	],
	"./cabinet/modules/finances/modules/transactions/views/navigation": [
		"d1a7",
		9,
		"chunk-2d21d9f9"
	],
	"./cabinet/modules/finances/modules/transactions/views/navigation.js": [
		"d1a7",
		9,
		"chunk-2d21d9f9"
	],
	"./cabinet/modules/finances/modules/transactions/views/transformers": [
		"afdc",
		9,
		"chunk-2d21445a"
	],
	"./cabinet/modules/finances/modules/transactions/views/transformers.js": [
		"afdc",
		9,
		"chunk-2d21445a"
	],
	"./cabinet/modules/finances/modules/transfers/components/Form": [
		"25c9",
		9,
		"chunk-2d0b2eaf"
	],
	"./cabinet/modules/finances/modules/transfers/components/Form.vue": [
		"25c9",
		9,
		"chunk-2d0b2eaf"
	],
	"./cabinet/modules/finances/modules/transfers/components/HistoryTable": [
		"0e78",
		9,
		"chunk-2d0af4cc"
	],
	"./cabinet/modules/finances/modules/transfers/components/HistoryTable.vue": [
		"0e78",
		9,
		"chunk-2d0af4cc"
	],
	"./cabinet/modules/finances/modules/transfers/components/List": [
		"cd20",
		9,
		"chunk-34b941fc"
	],
	"./cabinet/modules/finances/modules/transfers/components/List.vue": [
		"cd20",
		9,
		"chunk-34b941fc"
	],
	"./cabinet/modules/finances/modules/transfers/router": [
		"2f17",
		9
	],
	"./cabinet/modules/finances/modules/transfers/router.js": [
		"2f17",
		9
	],
	"./cabinet/modules/finances/modules/transfers/views/ChangeClientRateModal": [
		"5c5f",
		9,
		"chunk-236480d6"
	],
	"./cabinet/modules/finances/modules/transfers/views/ChangeClientRateModal.vue": [
		"5c5f",
		9,
		"chunk-236480d6"
	],
	"./cabinet/modules/finances/modules/transfers/views/ChangeEnterRateModal": [
		"d282",
		9,
		"chunk-805c0666"
	],
	"./cabinet/modules/finances/modules/transfers/views/ChangeEnterRateModal.vue": [
		"d282",
		9,
		"chunk-805c0666"
	],
	"./cabinet/modules/finances/modules/transfers/views/ChangeStatusModal": [
		"3c01",
		9,
		"chunk-d028bcb8"
	],
	"./cabinet/modules/finances/modules/transfers/views/ChangeStatusModal.vue": [
		"3c01",
		9,
		"chunk-d028bcb8"
	],
	"./cabinet/modules/finances/modules/transfers/views/ChangeTetherRateModal": [
		"e21f",
		9,
		"chunk-3a86cd53"
	],
	"./cabinet/modules/finances/modules/transfers/views/ChangeTetherRateModal.vue": [
		"e21f",
		9,
		"chunk-3a86cd53"
	],
	"./cabinet/modules/finances/modules/transfers/views/Create": [
		"cc08",
		9,
		"chunk-1653353e"
	],
	"./cabinet/modules/finances/modules/transfers/views/Create.vue": [
		"cc08",
		9,
		"chunk-1653353e"
	],
	"./cabinet/modules/finances/modules/transfers/views/Edit": [
		"8d1f",
		9,
		"chunk-2a3eeab1"
	],
	"./cabinet/modules/finances/modules/transfers/views/Edit.vue": [
		"8d1f",
		9,
		"chunk-2a3eeab1"
	],
	"./cabinet/modules/finances/modules/transfers/views/List": [
		"7a8a",
		9,
		"chunk-328db2b2"
	],
	"./cabinet/modules/finances/modules/transfers/views/List/": [
		"7a8a",
		9,
		"chunk-328db2b2"
	],
	"./cabinet/modules/finances/modules/transfers/views/List/Display": [
		"e15e",
		9,
		"chunk-1eae33ac"
	],
	"./cabinet/modules/finances/modules/transfers/views/List/Display.vue": [
		"e15e",
		9,
		"chunk-1eae33ac"
	],
	"./cabinet/modules/finances/modules/transfers/views/List/DisplayHistory": [
		"efab",
		9,
		"chunk-7f298e1b"
	],
	"./cabinet/modules/finances/modules/transfers/views/List/DisplayHistory.vue": [
		"efab",
		9,
		"chunk-7f298e1b"
	],
	"./cabinet/modules/finances/modules/transfers/views/List/HistoryDisplayIndex": [
		"89f5",
		9,
		"chunk-bef36e00"
	],
	"./cabinet/modules/finances/modules/transfers/views/List/HistoryDisplayIndex.vue": [
		"89f5",
		9,
		"chunk-bef36e00"
	],
	"./cabinet/modules/finances/modules/transfers/views/List/index": [
		"7a8a",
		9,
		"chunk-328db2b2"
	],
	"./cabinet/modules/finances/modules/transfers/views/List/index.vue": [
		"7a8a",
		9,
		"chunk-328db2b2"
	],
	"./cabinet/modules/finances/modules/transfers/views/navigation": [
		"64b6",
		9,
		"chunk-2d0cfc48"
	],
	"./cabinet/modules/finances/modules/transfers/views/navigation.js": [
		"64b6",
		9,
		"chunk-2d0cfc48"
	],
	"./cabinet/modules/finances/modules/transfers/views/transformers": [
		"7f4e",
		9,
		"chunk-2d0e26f6"
	],
	"./cabinet/modules/finances/modules/transfers/views/transformers.js": [
		"7f4e",
		9,
		"chunk-2d0e26f6"
	],
	"./cabinet/modules/finances/router": [
		"5f3c",
		9
	],
	"./cabinet/modules/finances/router.js": [
		"5f3c",
		9
	],
	"./cabinet/modules/leads/components/Form": [
		"6b7f",
		9,
		"chunk-2d0da3f1"
	],
	"./cabinet/modules/leads/components/Form.vue": [
		"6b7f",
		9,
		"chunk-2d0da3f1"
	],
	"./cabinet/modules/leads/components/HistoryTable": [
		"0181",
		9,
		"chunk-2d0a31b0"
	],
	"./cabinet/modules/leads/components/HistoryTable.vue": [
		"0181",
		9,
		"chunk-2d0a31b0"
	],
	"./cabinet/modules/leads/components/List": [
		"8567",
		9,
		"chunk-2d0de374"
	],
	"./cabinet/modules/leads/components/List.vue": [
		"8567",
		9,
		"chunk-2d0de374"
	],
	"./cabinet/modules/leads/router": [
		"1e5b",
		9
	],
	"./cabinet/modules/leads/router.js": [
		"1e5b",
		9
	],
	"./cabinet/modules/leads/views/Comments": [
		"a0b1",
		9,
		"chunk-4156476e"
	],
	"./cabinet/modules/leads/views/Comments.vue": [
		"a0b1",
		9,
		"chunk-4156476e"
	],
	"./cabinet/modules/leads/views/Create": [
		"0a5e",
		9,
		"chunk-e75502be"
	],
	"./cabinet/modules/leads/views/Create.vue": [
		"0a5e",
		9,
		"chunk-e75502be"
	],
	"./cabinet/modules/leads/views/Edit": [
		"1572",
		9,
		"chunk-2d0c0e63",
		"chunk-0397e582"
	],
	"./cabinet/modules/leads/views/Edit.vue": [
		"1572",
		9,
		"chunk-2d0c0e63",
		"chunk-0397e582"
	],
	"./cabinet/modules/leads/views/List": [
		"51ec",
		9,
		"chunk-64b0f380",
		"chunk-79e60a5a"
	],
	"./cabinet/modules/leads/views/List/": [
		"51ec",
		9,
		"chunk-64b0f380",
		"chunk-79e60a5a"
	],
	"./cabinet/modules/leads/views/List/Clients": [
		"6599",
		9,
		"chunk-64b0f380",
		"chunk-2d0cfb15"
	],
	"./cabinet/modules/leads/views/List/Clients.vue": [
		"6599",
		9,
		"chunk-64b0f380",
		"chunk-2d0cfb15"
	],
	"./cabinet/modules/leads/views/List/Display": [
		"2705",
		9,
		"chunk-17bbb962"
	],
	"./cabinet/modules/leads/views/List/Display.vue": [
		"2705",
		9,
		"chunk-17bbb962"
	],
	"./cabinet/modules/leads/views/List/DisplayHistory": [
		"8451",
		9,
		"chunk-eee40138"
	],
	"./cabinet/modules/leads/views/List/DisplayHistory.vue": [
		"8451",
		9,
		"chunk-eee40138"
	],
	"./cabinet/modules/leads/views/List/HistoryDisplayIndex": [
		"82d1",
		9,
		"chunk-e8b39028"
	],
	"./cabinet/modules/leads/views/List/HistoryDisplayIndex.vue": [
		"82d1",
		9,
		"chunk-e8b39028"
	],
	"./cabinet/modules/leads/views/List/index": [
		"51ec",
		9,
		"chunk-64b0f380",
		"chunk-79e60a5a"
	],
	"./cabinet/modules/leads/views/List/index.vue": [
		"51ec",
		9,
		"chunk-64b0f380",
		"chunk-79e60a5a"
	],
	"./cabinet/modules/leads/views/navigation": [
		"83ec",
		9
	],
	"./cabinet/modules/leads/views/navigation.js": [
		"83ec",
		9
	],
	"./cabinet/modules/leads/views/transformers": [
		"8ec4",
		9,
		"chunk-2d0e9d14"
	],
	"./cabinet/modules/leads/views/transformers.js": [
		"8ec4",
		9,
		"chunk-2d0e9d14"
	],
	"./cabinet/modules/loc-delivery/components/CreateNPDocuments": [
		"bcee",
		9,
		"chunk-aab81f82"
	],
	"./cabinet/modules/loc-delivery/components/CreateNPDocuments.vue": [
		"bcee",
		9,
		"chunk-aab81f82"
	],
	"./cabinet/modules/loc-delivery/components/DeleteNPDocument": [
		"235d",
		9,
		"chunk-2e15ce76"
	],
	"./cabinet/modules/loc-delivery/components/DeleteNPDocument.vue": [
		"235d",
		9,
		"chunk-2e15ce76"
	],
	"./cabinet/modules/loc-delivery/components/Form": [
		"5581",
		9,
		"chunk-1878da6c"
	],
	"./cabinet/modules/loc-delivery/components/Form.vue": [
		"5581",
		9,
		"chunk-1878da6c"
	],
	"./cabinet/modules/loc-delivery/components/HistoryTable": [
		"88ef",
		9,
		"chunk-2d0df497"
	],
	"./cabinet/modules/loc-delivery/components/HistoryTable.vue": [
		"88ef",
		9,
		"chunk-2d0df497"
	],
	"./cabinet/modules/loc-delivery/components/InfoModal": [
		"fbba",
		9,
		"chunk-33005fde"
	],
	"./cabinet/modules/loc-delivery/components/InfoModal.vue": [
		"fbba",
		9,
		"chunk-33005fde"
	],
	"./cabinet/modules/loc-delivery/components/List": [
		"370b",
		9,
		"chunk-10eac646"
	],
	"./cabinet/modules/loc-delivery/components/List.vue": [
		"370b",
		9,
		"chunk-10eac646"
	],
	"./cabinet/modules/loc-delivery/components/ParcelsClientList": [
		"53e2",
		9,
		"chunk-090471e0",
		"chunk-33005fde"
	],
	"./cabinet/modules/loc-delivery/components/ParcelsClientList.vue": [
		"53e2",
		9,
		"chunk-090471e0",
		"chunk-33005fde"
	],
	"./cabinet/modules/loc-delivery/router": [
		"aec0",
		9
	],
	"./cabinet/modules/loc-delivery/router.js": [
		"aec0",
		9
	],
	"./cabinet/modules/loc-delivery/views/Create": [
		"061f",
		9,
		"chunk-1878da6c",
		"chunk-15d12d02"
	],
	"./cabinet/modules/loc-delivery/views/Create.vue": [
		"061f",
		9,
		"chunk-1878da6c",
		"chunk-15d12d02"
	],
	"./cabinet/modules/loc-delivery/views/Edit": [
		"9be1",
		9,
		"chunk-1878da6c",
		"chunk-3153c9af"
	],
	"./cabinet/modules/loc-delivery/views/Edit.vue": [
		"9be1",
		9,
		"chunk-1878da6c",
		"chunk-3153c9af"
	],
	"./cabinet/modules/loc-delivery/views/List": [
		"cab8",
		9,
		"chunk-4c5fa3a2"
	],
	"./cabinet/modules/loc-delivery/views/List/": [
		"cab8",
		9,
		"chunk-4c5fa3a2"
	],
	"./cabinet/modules/loc-delivery/views/List/Display": [
		"1d49",
		9,
		"chunk-72631192"
	],
	"./cabinet/modules/loc-delivery/views/List/Display.vue": [
		"1d49",
		9,
		"chunk-72631192"
	],
	"./cabinet/modules/loc-delivery/views/List/DisplayHistory": [
		"77c6",
		9,
		"chunk-7dd52362"
	],
	"./cabinet/modules/loc-delivery/views/List/DisplayHistory.vue": [
		"77c6",
		9,
		"chunk-7dd52362"
	],
	"./cabinet/modules/loc-delivery/views/List/HistoryDisplayIndex": [
		"38e7",
		9,
		"chunk-fee1b97c"
	],
	"./cabinet/modules/loc-delivery/views/List/HistoryDisplayIndex.vue": [
		"38e7",
		9,
		"chunk-fee1b97c"
	],
	"./cabinet/modules/loc-delivery/views/List/index": [
		"cab8",
		9,
		"chunk-4c5fa3a2"
	],
	"./cabinet/modules/loc-delivery/views/List/index.vue": [
		"cab8",
		9,
		"chunk-4c5fa3a2"
	],
	"./cabinet/modules/loc-delivery/views/navigation": [
		"e624",
		9,
		"chunk-2d225b69"
	],
	"./cabinet/modules/loc-delivery/views/navigation.js": [
		"e624",
		9,
		"chunk-2d225b69"
	],
	"./cabinet/modules/loc-delivery/views/transformers": [
		"152f",
		9,
		"chunk-2d0ab48e"
	],
	"./cabinet/modules/loc-delivery/views/transformers.js": [
		"152f",
		9,
		"chunk-2d0ab48e"
	],
	"./cabinet/modules/notifications/components/List": [
		"6a3c",
		9,
		"chunk-2d0d9fb1"
	],
	"./cabinet/modules/notifications/components/List.vue": [
		"6a3c",
		9,
		"chunk-2d0d9fb1"
	],
	"./cabinet/modules/notifications/router": [
		"6582",
		9
	],
	"./cabinet/modules/notifications/router.js": [
		"6582",
		9
	],
	"./cabinet/modules/notifications/views/Create": [
		"af95",
		9,
		"chunk-56c7897b"
	],
	"./cabinet/modules/notifications/views/Create.vue": [
		"af95",
		9,
		"chunk-56c7897b"
	],
	"./cabinet/modules/notifications/views/Edit": [
		"eb3b",
		9,
		"chunk-2bba51ac"
	],
	"./cabinet/modules/notifications/views/Edit.vue": [
		"eb3b",
		9,
		"chunk-2bba51ac"
	],
	"./cabinet/modules/notifications/views/List": [
		"7f2b",
		9,
		"chunk-07885bdb"
	],
	"./cabinet/modules/notifications/views/List/": [
		"7f2b",
		9,
		"chunk-07885bdb"
	],
	"./cabinet/modules/notifications/views/List/Display": [
		"e732",
		9,
		"chunk-9ae4a13c"
	],
	"./cabinet/modules/notifications/views/List/Display.vue": [
		"e732",
		9,
		"chunk-9ae4a13c"
	],
	"./cabinet/modules/notifications/views/List/index": [
		"7f2b",
		9,
		"chunk-07885bdb"
	],
	"./cabinet/modules/notifications/views/List/index.vue": [
		"7f2b",
		9,
		"chunk-07885bdb"
	],
	"./cabinet/modules/notifications/views/ReadNotificationModal": [
		"b7b6",
		9,
		"chunk-2d2107df"
	],
	"./cabinet/modules/notifications/views/ReadNotificationModal.vue": [
		"b7b6",
		9,
		"chunk-2d2107df"
	],
	"./cabinet/modules/notifications/views/navigation": [
		"cc42",
		9,
		"chunk-2d221bd4"
	],
	"./cabinet/modules/notifications/views/navigation.js": [
		"cc42",
		9,
		"chunk-2d221bd4"
	],
	"./cabinet/modules/notifications/views/transformers": [
		"880c",
		9,
		"chunk-2d0dee29"
	],
	"./cabinet/modules/notifications/views/transformers.js": [
		"880c",
		9,
		"chunk-2d0dee29"
	],
	"./cabinet/modules/novaposhta/modules/documents/components/List": [
		"d12c",
		9,
		"chunk-2d21d474"
	],
	"./cabinet/modules/novaposhta/modules/documents/components/List.vue": [
		"d12c",
		9,
		"chunk-2d21d474"
	],
	"./cabinet/modules/novaposhta/modules/documents/router": [
		"cef7",
		9
	],
	"./cabinet/modules/novaposhta/modules/documents/router.js": [
		"cef7",
		9
	],
	"./cabinet/modules/novaposhta/modules/documents/views/ChangeScanSheetModal": [
		"ed92",
		9,
		"chunk-5a112ac6"
	],
	"./cabinet/modules/novaposhta/modules/documents/views/ChangeScanSheetModal.vue": [
		"ed92",
		9,
		"chunk-5a112ac6"
	],
	"./cabinet/modules/novaposhta/modules/documents/views/DeleteDocumentsModal": [
		"e762",
		9,
		"chunk-1ca054b2"
	],
	"./cabinet/modules/novaposhta/modules/documents/views/DeleteDocumentsModal.vue": [
		"e762",
		9,
		"chunk-1ca054b2"
	],
	"./cabinet/modules/novaposhta/modules/documents/views/List": [
		"dad0",
		9,
		"chunk-d22c48b6"
	],
	"./cabinet/modules/novaposhta/modules/documents/views/List/": [
		"dad0",
		9,
		"chunk-d22c48b6"
	],
	"./cabinet/modules/novaposhta/modules/documents/views/List/Display": [
		"0873",
		9,
		"chunk-8a993f48"
	],
	"./cabinet/modules/novaposhta/modules/documents/views/List/Display.vue": [
		"0873",
		9,
		"chunk-8a993f48"
	],
	"./cabinet/modules/novaposhta/modules/documents/views/List/Preview": [
		"d2b7",
		9,
		"chunk-6e3dc9ce"
	],
	"./cabinet/modules/novaposhta/modules/documents/views/List/Preview.vue": [
		"d2b7",
		9,
		"chunk-6e3dc9ce"
	],
	"./cabinet/modules/novaposhta/modules/documents/views/List/index": [
		"dad0",
		9,
		"chunk-d22c48b6"
	],
	"./cabinet/modules/novaposhta/modules/documents/views/List/index.vue": [
		"dad0",
		9,
		"chunk-d22c48b6"
	],
	"./cabinet/modules/novaposhta/modules/documents/views/navigation": [
		"2d6f",
		9,
		"chunk-2d0bd9d8"
	],
	"./cabinet/modules/novaposhta/modules/documents/views/navigation.js": [
		"2d6f",
		9,
		"chunk-2d0bd9d8"
	],
	"./cabinet/modules/novaposhta/modules/documents/views/transformers": [
		"f213",
		7,
		"chunk-2d22c0a4"
	],
	"./cabinet/modules/novaposhta/modules/documents/views/transformers.js": [
		"f213",
		7,
		"chunk-2d22c0a4"
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/components/Form": [
		"47fe",
		9,
		"chunk-2d0c1f78"
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/components/Form.vue": [
		"47fe",
		9,
		"chunk-2d0c1f78"
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/components/List": [
		"24cc",
		9,
		"chunk-2d0b2b18"
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/components/List.vue": [
		"24cc",
		9,
		"chunk-2d0b2b18"
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/router": [
		"8d83",
		9
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/router.js": [
		"8d83",
		9
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/views/DisbandScanSheet": [
		"a476",
		9,
		"chunk-b6979e7a"
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/views/DisbandScanSheet.vue": [
		"a476",
		9,
		"chunk-b6979e7a"
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/views/List": [
		"c2f4",
		9,
		"chunk-ae1c0e24"
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/views/List/": [
		"c2f4",
		9,
		"chunk-ae1c0e24"
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/views/List/Display": [
		"c02e",
		9,
		"chunk-a0677fc2"
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/views/List/Display.vue": [
		"c02e",
		9,
		"chunk-a0677fc2"
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/views/List/index": [
		"c2f4",
		9,
		"chunk-ae1c0e24"
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/views/List/index.vue": [
		"c2f4",
		9,
		"chunk-ae1c0e24"
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/views/navigation": [
		"3145",
		9,
		"chunk-2d0b8e55"
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/views/navigation.js": [
		"3145",
		9,
		"chunk-2d0b8e55"
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/views/transformers": [
		"1d2a",
		9,
		"chunk-2d0b64f8"
	],
	"./cabinet/modules/novaposhta/modules/scan-sheet/views/transformers.js": [
		"1d2a",
		9,
		"chunk-2d0b64f8"
	],
	"./cabinet/modules/novaposhta/router": [
		"832a",
		9
	],
	"./cabinet/modules/novaposhta/router.js": [
		"832a",
		9
	],
	"./cabinet/modules/orders/components/Form": [
		"6ebc",
		9,
		"chunk-2d0db466"
	],
	"./cabinet/modules/orders/components/Form.vue": [
		"6ebc",
		9,
		"chunk-2d0db466"
	],
	"./cabinet/modules/orders/components/HistoryTable": [
		"b800",
		9,
		"chunk-2d21058c"
	],
	"./cabinet/modules/orders/components/HistoryTable.vue": [
		"b800",
		9,
		"chunk-2d21058c"
	],
	"./cabinet/modules/orders/components/List": [
		"0013",
		9,
		"chunk-2d0a2d18"
	],
	"./cabinet/modules/orders/components/List.vue": [
		"0013",
		9,
		"chunk-2d0a2d18"
	],
	"./cabinet/modules/orders/router": [
		"8511",
		9
	],
	"./cabinet/modules/orders/router.js": [
		"8511",
		9
	],
	"./cabinet/modules/orders/views/Create": [
		"c2fb",
		9,
		"chunk-36159b33"
	],
	"./cabinet/modules/orders/views/Create.vue": [
		"c2fb",
		9,
		"chunk-36159b33"
	],
	"./cabinet/modules/orders/views/Edit": [
		"3f30",
		9,
		"chunk-aa3e1ddc"
	],
	"./cabinet/modules/orders/views/Edit/": [
		"3f30",
		9,
		"chunk-aa3e1ddc"
	],
	"./cabinet/modules/orders/views/Edit/index": [
		"3f30",
		9,
		"chunk-aa3e1ddc"
	],
	"./cabinet/modules/orders/views/Edit/index.vue": [
		"3f30",
		9,
		"chunk-aa3e1ddc"
	],
	"./cabinet/modules/orders/views/List": [
		"3fd5",
		9,
		"chunk-6532a0cf"
	],
	"./cabinet/modules/orders/views/List/": [
		"3fd5",
		9,
		"chunk-6532a0cf"
	],
	"./cabinet/modules/orders/views/List/Display": [
		"7a18",
		9,
		"chunk-63e2d97c"
	],
	"./cabinet/modules/orders/views/List/Display.vue": [
		"7a18",
		9,
		"chunk-63e2d97c"
	],
	"./cabinet/modules/orders/views/List/DisplayHistory": [
		"fa55",
		9,
		"chunk-d3abe81c"
	],
	"./cabinet/modules/orders/views/List/DisplayHistory.vue": [
		"fa55",
		9,
		"chunk-d3abe81c"
	],
	"./cabinet/modules/orders/views/List/HistoryDisplayIndex": [
		"84ae",
		9,
		"chunk-4a80c715"
	],
	"./cabinet/modules/orders/views/List/HistoryDisplayIndex.vue": [
		"84ae",
		9,
		"chunk-4a80c715"
	],
	"./cabinet/modules/orders/views/List/index": [
		"3fd5",
		9,
		"chunk-6532a0cf"
	],
	"./cabinet/modules/orders/views/List/index.vue": [
		"3fd5",
		9,
		"chunk-6532a0cf"
	],
	"./cabinet/modules/orders/views/navigation": [
		"3e86",
		9,
		"chunk-2d0c5206"
	],
	"./cabinet/modules/orders/views/navigation.js": [
		"3e86",
		9,
		"chunk-2d0c5206"
	],
	"./cabinet/modules/orders/views/transformers": [
		"09a4",
		9,
		"chunk-2d0a54b2"
	],
	"./cabinet/modules/orders/views/transformers.js": [
		"09a4",
		9,
		"chunk-2d0a54b2"
	],
	"./cabinet/modules/profile/View": [
		"2833",
		9,
		"chunk-02555431",
		"chunk-2d0c0e63",
		"chunk-44365900",
		"chunk-0c1af9c4",
		"chunk-2e5fb901"
	],
	"./cabinet/modules/profile/View.vue": [
		"2833",
		9,
		"chunk-02555431",
		"chunk-2d0c0e63",
		"chunk-44365900",
		"chunk-0c1af9c4",
		"chunk-2e5fb901"
	],
	"./cabinet/modules/profile/router": [
		"30ff",
		9
	],
	"./cabinet/modules/profile/router.js": [
		"30ff",
		9
	],
	"./cabinet/modules/staff/components/Form": [
		"fa43",
		9,
		"chunk-28e2037e"
	],
	"./cabinet/modules/staff/components/Form.vue": [
		"fa43",
		9,
		"chunk-28e2037e"
	],
	"./cabinet/modules/staff/components/List": [
		"283c",
		9,
		"chunk-2d0b344c"
	],
	"./cabinet/modules/staff/components/List.vue": [
		"283c",
		9,
		"chunk-2d0b344c"
	],
	"./cabinet/modules/staff/components/TelegramManagerAccountForm": [
		"655a",
		9,
		"chunk-44365900"
	],
	"./cabinet/modules/staff/components/TelegramManagerAccountForm.vue": [
		"655a",
		9,
		"chunk-44365900"
	],
	"./cabinet/modules/staff/components/TelegramManagerAuthModal": [
		"4eb4",
		9,
		"chunk-2d0ccb79"
	],
	"./cabinet/modules/staff/components/TelegramManagerAuthModal.vue": [
		"4eb4",
		9,
		"chunk-2d0ccb79"
	],
	"./cabinet/modules/staff/components/TelegramManagerDisconnectConfirmModal": [
		"2125",
		9,
		"chunk-2d0b19b8"
	],
	"./cabinet/modules/staff/components/TelegramManagerDisconnectConfirmModal.vue": [
		"2125",
		9,
		"chunk-2d0b19b8"
	],
	"./cabinet/modules/staff/router": [
		"b428",
		9
	],
	"./cabinet/modules/staff/router.js": [
		"b428",
		9
	],
	"./cabinet/modules/staff/views/Create": [
		"e80d",
		9,
		"chunk-5c88a595"
	],
	"./cabinet/modules/staff/views/Create.vue": [
		"e80d",
		9,
		"chunk-5c88a595"
	],
	"./cabinet/modules/staff/views/EditAccountantType": [
		"1d7e",
		9,
		"chunk-b201f162"
	],
	"./cabinet/modules/staff/views/EditAccountantType.vue": [
		"1d7e",
		9,
		"chunk-b201f162"
	],
	"./cabinet/modules/staff/views/EditAssistant": [
		"c6e8",
		9,
		"chunk-7f87c614"
	],
	"./cabinet/modules/staff/views/EditAssistant.vue": [
		"c6e8",
		9,
		"chunk-7f87c614"
	],
	"./cabinet/modules/staff/views/EditCashbox": [
		"9729",
		9,
		"chunk-9d2692da"
	],
	"./cabinet/modules/staff/views/EditCashbox.vue": [
		"9729",
		9,
		"chunk-9d2692da"
	],
	"./cabinet/modules/staff/views/EditCeo": [
		"fccf",
		9,
		"chunk-9695e9e4"
	],
	"./cabinet/modules/staff/views/EditCeo.vue": [
		"fccf",
		9,
		"chunk-9695e9e4"
	],
	"./cabinet/modules/staff/views/EditManager": [
		"82a0",
		9,
		"chunk-44365900",
		"chunk-f8c069d2"
	],
	"./cabinet/modules/staff/views/EditManager.vue": [
		"82a0",
		9,
		"chunk-44365900",
		"chunk-f8c069d2"
	],
	"./cabinet/modules/staff/views/EditOperationsManager": [
		"ae65",
		9,
		"chunk-4e47a791"
	],
	"./cabinet/modules/staff/views/EditOperationsManager.vue": [
		"ae65",
		9,
		"chunk-4e47a791"
	],
	"./cabinet/modules/staff/views/EditStockman": [
		"ce7d",
		9,
		"chunk-1ce5929d"
	],
	"./cabinet/modules/staff/views/EditStockman.vue": [
		"ce7d",
		9,
		"chunk-1ce5929d"
	],
	"./cabinet/modules/staff/views/EditStockmanOperator": [
		"13db",
		9,
		"chunk-1990c164"
	],
	"./cabinet/modules/staff/views/EditStockmanOperator.vue": [
		"13db",
		9,
		"chunk-1990c164"
	],
	"./cabinet/modules/staff/views/EditTransferType": [
		"24fb",
		9,
		"chunk-46763cac"
	],
	"./cabinet/modules/staff/views/EditTransferType.vue": [
		"24fb",
		9,
		"chunk-46763cac"
	],
	"./cabinet/modules/staff/views/List": [
		"a6c6",
		9,
		"chunk-4c50bd08"
	],
	"./cabinet/modules/staff/views/List/": [
		"a6c6",
		9,
		"chunk-4c50bd08"
	],
	"./cabinet/modules/staff/views/List/Display": [
		"ce82",
		9,
		"chunk-55337173"
	],
	"./cabinet/modules/staff/views/List/Display.vue": [
		"ce82",
		9,
		"chunk-55337173"
	],
	"./cabinet/modules/staff/views/List/index": [
		"a6c6",
		9,
		"chunk-4c50bd08"
	],
	"./cabinet/modules/staff/views/List/index.vue": [
		"a6c6",
		9,
		"chunk-4c50bd08"
	],
	"./cabinet/modules/staff/views/navigation": [
		"bbb2",
		9,
		"chunk-2d21a946"
	],
	"./cabinet/modules/staff/views/navigation.js": [
		"bbb2",
		9,
		"chunk-2d21a946"
	],
	"./cabinet/modules/staff/views/transformers": [
		"f107",
		9,
		"chunk-2d22bcc8"
	],
	"./cabinet/modules/staff/views/transformers.js": [
		"f107",
		9,
		"chunk-2d22bcc8"
	],
	"./cabinet/modules/tg-chats/components/TelegramChatConversation": [
		"36c8",
		9
	],
	"./cabinet/modules/tg-chats/components/TelegramChatConversation.vue": [
		"36c8",
		9
	],
	"./cabinet/modules/tg-chats/components/TelegramChatIdentifyModal": [
		"32ed",
		9
	],
	"./cabinet/modules/tg-chats/components/TelegramChatIdentifyModal.vue": [
		"32ed",
		9
	],
	"./cabinet/modules/tg-chats/components/TelegramChatRelinkModal": [
		"3365",
		9
	],
	"./cabinet/modules/tg-chats/components/TelegramChatRelinkModal.vue": [
		"3365",
		9
	],
	"./cabinet/modules/tg-chats/components/TelegramChatUnlinkConfirmModal": [
		"c776",
		9
	],
	"./cabinet/modules/tg-chats/components/TelegramChatUnlinkConfirmModal.vue": [
		"c776",
		9
	],
	"./cabinet/modules/tg-chats/components/TelegramChatsByManager": [
		"35ec",
		9
	],
	"./cabinet/modules/tg-chats/components/TelegramChatsByManager.vue": [
		"35ec",
		9
	],
	"./cabinet/modules/tg-chats/components/TelegramMessageComposer": [
		"1f00",
		9
	],
	"./cabinet/modules/tg-chats/components/TelegramMessageComposer.vue": [
		"1f00",
		9
	],
	"./cabinet/modules/tg-chats/router": [
		"d6cf",
		9
	],
	"./cabinet/modules/tg-chats/router.js": [
		"d6cf",
		9
	],
	"./cabinet/modules/tg-chats/views/UnidentifiedChats": [
		"95af",
		9
	],
	"./cabinet/modules/tg-chats/views/UnidentifiedChats.vue": [
		"95af",
		9
	],
	"./cabinet/navigation": [
		"7ed2",
		9
	],
	"./cabinet/navigation.js": [
		"7ed2",
		9
	],
	"./cabinet/router": [
		"ec71",
		9
	],
	"./cabinet/router.js": [
		"ec71",
		9
	],
	"./cabinet/views/Cabinet": [
		"f738",
		9,
		"chunk-bbf6dce0"
	],
	"./cabinet/views/Cabinet.vue": [
		"f738",
		9,
		"chunk-bbf6dce0"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9f9a";
module.exports = webpackAsyncContext;